import React from 'react';
import { List, Datagrid, TextField, NumberField, DateField, Filter, TextInput } from 'react-admin';
import CustomReportListActions from '../../../../commonComponents/ListActions/CustomReportListActions';

const CrosswordRewardsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User ID" source="user_id" />
    <TextInput label="Crossword ID" source="crossword_id" />
    <TextInput label="Level ID" source="item_id" />
  </Filter>
);

const CrosswordRewardsList = (props) => (
  <List
    {...props}
    filters={<CrosswordRewardsFilter />}
    sort={{ field: 'created_at', order: 'DESC' }}
    actions={<CustomReportListActions exporter />}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="user_id" label="User ID" />
      <TextField source="crossword_id" label="Crossword ID" />
      <TextField source="item_id" label="Level ID" />
      <NumberField source="credits_awarded" label="Credits Awarded" />
      <DateField source="created_at" label="Created At" textAlign="right" headerStyle={{ textAlign: 'right' }} />
    </Datagrid>
  </List>
);

export default CrosswordRewardsList;
